// extracted by mini-css-extract-plugin
export default {"selector":"FareClassSelector_selector__S-xy2","label":"FareClassSelector_label__cO511"};